import { render, staticRenderFns } from "./bimTextH2.vue?vue&type=template&id=037e675e&scoped=true&lang=html&"
import script from "./bimTextH2.vue?vue&type=script&lang=js&"
export * from "./bimTextH2.vue?vue&type=script&lang=js&"
import style0 from "./bimTextH2.vue?vue&type=style&index=0&id=037e675e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037e675e",
  null
  
)

export default component.exports